module.exports = __webpack_public_path__ + "static/media/penalities.c74a527e.svg";